import styled from "styled-components";
import { Container } from "@viagogo/core/ui";

export const ContainerWithMargin = styled(Container)`
  margin: ${(props) => props.theme.spacing(2, 0, 12, 0)};
  @media ${({ theme: { media } }) => media.tablet} {
    margin: ${(props) => props.theme.spacing(4, 4, 12, 4)};
  }
  @media ${({ theme: { media } }) => media.desktop} {
    margin: ${(props) => props.theme.spacing(8, 8, 12, 8)};
  }
  ${(props) => props.theme.media.makeMediaQuery(1200, `margin: ${props.theme.spacing(8)} auto;`)}
`;

export const PaddedDiv = styled.div`
  @media ${({ theme: { media } }) => media.phone} {
    padding: ${(props) => props.theme.spacing(0, 4)};
  }
`;
